(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1281],{

/***/ 27915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Table; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/components/Abstracts/Table/styles.module.scss
var styles_module = __webpack_require__(13717);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/Table/index.tsx




var cx = bind_default().bind((styles_module_default()));
function Table(param) {
    var className = param.className, thead = param.thead, tbody = param.tbody, hasDifferentLayoutInDesktop = param.hasDifferentLayoutInDesktop, combinedTbody = param.combinedTbody, theadClassName = param.theadClassName, tbodyClassName = param.tbodyClassName, desktopTbodyClassName = param.desktopTbodyClassName, firstColumnDesktopClassName = param.firstColumnDesktopClassName;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: cx((styles_module_default()).Table, className),
        children: [
            thead && /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                className: cx((styles_module_default()).thead, theadClassName, hasDifferentLayoutInDesktop ? (styles_module_default()).hideOnLargeScreen : null),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: thead === null || thead === void 0 ? void 0 : (ref = thead.values) === null || ref === void 0 ? void 0 : ref.map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: value
                        }, "thead_td_".concat(index));
                    })
                })
            }),
            tbody && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                className: cx((styles_module_default()).tbody, tbodyClassName, hasDifferentLayoutInDesktop ? (styles_module_default()).hideOnLargeScreen : null),
                children: tbody === null || tbody === void 0 ? void 0 : tbody.map(function(row, rowIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                        children: row === null || row === void 0 ? void 0 : (ref = row.values) === null || ref === void 0 ? void 0 : ref.map(function(value, columnIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: value
                            }, "tbody_tr_".concat(rowIndex, "_td_").concat(columnIndex));
                        })
                    }, "tbody_tr_".concat(rowIndex));
                })
            }),
            hasDifferentLayoutInDesktop && combinedTbody && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                className: cx((styles_module_default()).tbodyDesktop, desktopTbodyClassName, (styles_module_default()).hideOnSmallScreen),
                children: combinedTbody === null || combinedTbody === void 0 ? void 0 : combinedTbody.map(function(row, rowIndex) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                        children: row === null || row === void 0 ? void 0 : (ref = row.values) === null || ref === void 0 ? void 0 : ref.map(function(value, columnIndex) {
                            var isFirstColumn = columnIndex === 0;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                className: isFirstColumn ? cx((styles_module_default()).isFirst, firstColumnDesktopClassName) : null,
                                children: value
                            }, "tbody_tr_desktop_".concat(rowIndex, "_td_").concat(columnIndex));
                        })
                    }, "tbody_tr_desktop_".concat(rowIndex));
                })
            })
        ]
    });
}
Table.defaultProps = {};
/* harmony default export */ var Abstracts_Table = (Table);

// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/Table/styles.module.scss
var Table_styles_module = __webpack_require__(20061);
var Table_styles_module_default = /*#__PURE__*/__webpack_require__.n(Table_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Table/index.tsx










var Table_cx = bind_default().bind((Table_styles_module_default()));
function Table_Table(_param) {
    var className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var tableStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var labelsStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abstracts_Table, (0,_object_spread/* default */.Z)({
        className: Table_cx((Table_styles_module_default()).Table, className, tableStyle),
        theadClassName: Table_cx((Table_styles_module_default()).thead, labelsStyle),
        tbodyClassName: (Table_styles_module_default()).tbody,
        desktopTbodyClassName: (Table_styles_module_default()).tbodyDesktop,
        firstColumnDesktopClassName: Table_cx((Table_styles_module_default()).firstColumnDesktop, labelsStyle)
    }, rest));
}
Table_Table.defaultProps = {};
/* harmony default export */ var UI_Table = (Table_Table);


/***/ }),

/***/ 61281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ TwoColumnsLayoutsTypes; },
  "Z": function() { return /* binding */ UI_TwoColumnsLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./src/components/Abstracts/ProductsPins/index.tsx + 2 modules
var ProductsPins = __webpack_require__(86564);
// EXTERNAL MODULE: ./src/components/Slices/ImageWithLabel/index.tsx
var ImageWithLabel = __webpack_require__(53299);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Accordion/index.js
var Accordion = __webpack_require__(99385);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Accordion/AccordionPanel/index.js
var AccordionPanel = __webpack_require__(4903);
// EXTERNAL MODULE: ./src/components/UI/RichText/index.tsx
var RichText = __webpack_require__(55071);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/hooks/useTextColorFromTheme/index.ts
var useTextColorFromTheme = __webpack_require__(27216);
// EXTERNAL MODULE: ./src/components/UI/AccordionItems/styles.module.scss
var styles_module = __webpack_require__(34928);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/AccordionItems/index.tsx









var cx = bind_default().bind((styles_module_default()));
function AccordionItems(param) {
    var className = param.className, headlineClassName = param.headlineClassName, bodyClassName = param.bodyClassName, items = param.items, index = param.index, _bordersTheme = param.bordersTheme, bordersTheme = _bordersTheme === void 0 ? colors/* GlobalThemeColors.SilverChalice */.b.SilverChalice : _bordersTheme, activeIcon = param.activeIcon, inactiveIcon = param.inactiveIcon;
    var ref = (0,useTextColorFromTheme/* default */.Z)(), color = ref.textColor;
    var accordionStyle = (0,StyleProvider/* useStyle */.X)({
        borderColor: bordersTheme !== null && bordersTheme !== void 0 ? bordersTheme : color
    });
    var iconStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Cta10Grotesk */.C.Cta10Grotesk
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx((styles_module_default()).Accordion, className, accordionStyle),
        children: (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.UQ, {
            index: index,
            children: items === null || items === void 0 ? void 0 : items.map(function(param, key) {
                var headline = param.headline, body = param.body;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionPanel/* AccordionPanel */.H, {
                    className: cx((styles_module_default()).panel, accordionStyle),
                    index: key,
                    head: function(isActive) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: cx((styles_module_default()).panelHead, {
                                isActive: isActive
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: cx((styles_module_default()).headline, headlineClassName),
                                    children: headline
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: cx((styles_module_default()).icon, iconStyle),
                                    children: [
                                        (activeIcon && inactiveIcon && isActive || activeIcon && !inactiveIcon) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: activeIcon
                                        }),
                                        inactiveIcon && !isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: inactiveIcon
                                        }),
                                        !activeIcon && !isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "(+)"
                                        }),
                                        !activeIcon && isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "(–)"
                                        })
                                    ]
                                })
                            ]
                        });
                    },
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx((styles_module_default()).panelBody),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                            className: cx((styles_module_default()).text, bodyClassName),
                            render: body
                        })
                    })
                }, "item_".concat(key));
            })
        })
    });
}
AccordionItems.defaultProps = {
    index: 0
};
/* harmony default export */ var UI_AccordionItems = (AccordionItems);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-value.mjs
var use_motion_value = __webpack_require__(4960);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/animate.mjs + 12 modules
var animate = __webpack_require__(24213);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 19 modules
var motion_minimal = __webpack_require__(57891);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useMeasureObserver/index.js
var useMeasureObserver = __webpack_require__(88300);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.tsx + 17 modules
var Icons = __webpack_require__(54678);
// EXTERNAL MODULE: ./src/components/UI/Table/index.tsx + 1 modules
var Table = __webpack_require__(27915);
// EXTERNAL MODULE: ./src/components/UI/CustomTable/styles.module.scss
var CustomTable_styles_module = __webpack_require__(37384);
var CustomTable_styles_module_default = /*#__PURE__*/__webpack_require__.n(CustomTable_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/CustomTable/index.tsx











var CustomTable_cx = bind_default().bind((CustomTable_styles_module_default()));
function CustomTable(_param) {
    var className = _param.className, table = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var componentRef = (0,react.useRef)();
    var containerRef = (0,react.useRef)();
    var ref = (0,useMeasureObserver/* useMeasureObserver */.i)(containerRef, "getBoundingClientRect"), containerWidth = ref.width;
    var ref1 = (0,useMeasureObserver/* useMeasureObserver */.i)(componentRef, "getBoundingClientRect"), componentWidth = ref1.width;
    var scrollX = (0,use_motion_value/* useMotionValue */.c)(0);
    var offset = componentWidth - containerWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: CustomTable_cx((CustomTable_styles_module_default()).CustomTable, className),
        children: [
            offset > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: CustomTable_cx((CustomTable_styles_module_default()).nav),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (CustomTable_styles_module_default()).prev,
                        "aria-label": "nav-arrow-icon",
                        onClick: function() {
                            (0,animate/* animate */.j)(scrollX, -1 * (containerRef.current.scrollLeft - offset / 2 >= 0 ? containerRef.current.scrollLeft - offset / 2 : 0));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NavArrowIcon */.o9, {
                            className: CustomTable_cx((CustomTable_styles_module_default()).navIcon),
                            theme: colors/* GlobalThemeColors.Black */.b.Black
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (CustomTable_styles_module_default()).next,
                        "aria-label": "nav-arrow-icon",
                        onClick: function() {
                            (0,animate/* animate */.j)(scrollX, -1 * (scrollX.get() - offset / 2 > offset ? scrollX.get() - offset / 2 : offset));
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NavArrowIcon */.o9, {
                            className: CustomTable_cx((CustomTable_styles_module_default()).navIcon),
                            theme: colors/* GlobalThemeColors.Black */.b.Black
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: CustomTable_cx((CustomTable_styles_module_default()).wrapper),
                ref: containerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                    className: CustomTable_cx((CustomTable_styles_module_default()).tableContainer),
                    ref: componentRef,
                    style: {
                        x: scrollX
                    },
                    drag: "x",
                    dragConstraints: containerRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, (0,_object_spread/* default */.Z)({
                        className: CustomTable_cx((CustomTable_styles_module_default()).table)
                    }, table))
                })
            })
        ]
    });
}
/* harmony default export */ var UI_CustomTable = (CustomTable);

// EXTERNAL MODULE: ./src/components/Abstracts/RichText/index.tsx + 2 modules
var Abstracts_RichText = __webpack_require__(7191);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/components/UI/Quote/styles.module.scss
var Quote_styles_module = __webpack_require__(51896);
var Quote_styles_module_default = /*#__PURE__*/__webpack_require__.n(Quote_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Quote/index.tsx










var Quote_cx = bind_default().bind((Quote_styles_module_default()));
function Quote(param) {
    var className = param.className, quote = param.quote, cite = param.cite, link = param.link;
    var quoteStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text20_24SangBleu */.C.Text20_24SangBleu,
        textStyling: text_styling/* GlobalTextStyling.Italic */.l.Italic
    });
    var citeStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
        className: Quote_cx((Quote_styles_module_default()).Quote, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Abstracts_RichText/* default */.Z, {
                className: Quote_cx((Quote_styles_module_default()).quote, quoteStyle),
                render: quote
            }),
            cite && /*#__PURE__*/ (0,jsx_runtime.jsx)("cite", {
                className: Quote_cx((Quote_styles_module_default()).cite, citeStyle),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "- ",
                        " ",
                        link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                            children: cite
                        })) : cite
                    ]
                })
            })
        ]
    });
}
Quote.defaultProps = {};
/* harmony default export */ var UI_Quote = (Quote);

// EXTERNAL MODULE: ./src/components/UI/TwoColumnsAccordion/styles.module.scss
var TwoColumnsAccordion_styles_module = __webpack_require__(37023);
var TwoColumnsAccordion_styles_module_default = /*#__PURE__*/__webpack_require__.n(TwoColumnsAccordion_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/TwoColumnsAccordion/index.tsx









var TwoColumnsAccordion_cx = bind_default().bind((TwoColumnsAccordion_styles_module_default()));
function TwoColumnsAccordion(param) {
    var className = param.className, items = param.items, headlineClassName = param.headlineClassName, _bordersTheme = param.bordersTheme, bordersTheme = _bordersTheme === void 0 ? colors/* GlobalThemeColors.SilverChalice */.b.SilverChalice : _bordersTheme;
    var ref = (0,useTextColorFromTheme/* default */.Z)(), color = ref.textColor;
    var accordionStyle = (0,StyleProvider/* useStyle */.X)({
        borderColor: bordersTheme !== null && bordersTheme !== void 0 ? bordersTheme : color
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: TwoColumnsAccordion_cx((TwoColumnsAccordion_styles_module_default()).TwoColumnsAccordion, className, accordionStyle),
        children: (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.UQ, {
            index: 0,
            autoHide: false,
            children: items === null || items === void 0 ? void 0 : items.map(function(param, key) {
                var header = param.header, body = param.body;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(AccordionPanel/* AccordionPanel */.H, {
                    className: TwoColumnsAccordion_cx((TwoColumnsAccordion_styles_module_default()).panel, accordionStyle),
                    index: key,
                    head: function(isActive) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: TwoColumnsAccordion_cx((TwoColumnsAccordion_styles_module_default()).panelHead, headlineClassName, {
                                isActive: isActive
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: TwoColumnsAccordion_cx((TwoColumnsAccordion_styles_module_default()).headline),
                                    children: header
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: TwoColumnsAccordion_cx((TwoColumnsAccordion_styles_module_default()).icon),
                                    children: [
                                        !isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "(+)"
                                        }),
                                        isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "(–)"
                                        })
                                    ]
                                })
                            ]
                        });
                    },
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: TwoColumnsAccordion_cx((TwoColumnsAccordion_styles_module_default()).panelBody),
                        children: body === null || body === void 0 ? void 0 : body.map(function(row, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RightColumnRow, (0,_object_spread/* default */.Z)({
                                className: TwoColumnsAccordion_cx((TwoColumnsAccordion_styles_module_default()).row)
                            }, row), "row_".concat(key, "_").concat(index));
                        })
                    })
                }, "item_".concat(key));
            })
        })
    });
}
TwoColumnsAccordion.defaultProps = {};
/* harmony default export */ var UI_TwoColumnsAccordion = (TwoColumnsAccordion);

// EXTERNAL MODULE: ./src/components/UI/Wysiwyg/index.tsx
var Wysiwyg = __webpack_require__(85630);
// EXTERNAL MODULE: ./src/components/UI/TwoColumnsLayout/RightColumnRow/styles.module.scss
var RightColumnRow_styles_module = __webpack_require__(26182);
var RightColumnRow_styles_module_default = /*#__PURE__*/__webpack_require__.n(RightColumnRow_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/TwoColumnsLayout/RightColumnRow/index.tsx


















var RightColumnRow_cx = bind_default().bind((RightColumnRow_styles_module_default()));
function ColumnRow(param) {
    var className = param.className, content = param.content, isSingleItemHalfWidth = param.isSingleItemHalfWidth;
    var bodyStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text14GroteskRegular */.C.Text14GroteskRegular,
        color: colors/* GlobalThemeColors.Gray */.b.Gray
    });
    var headlineStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        color: colors/* GlobalThemeColors.Black */.b.Black,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: RightColumnRow_cx((RightColumnRow_styles_module_default()).RightColumnRow, className, (RightColumnRow_styles_module_default()) === null || (RightColumnRow_styles_module_default()) === void 0 ? void 0 : (RightColumnRow_styles_module_default())["layout-".concat(content === null || content === void 0 ? void 0 : content.length, "-items")], {
            singleHalfWidth: isSingleItemHalfWidth
        }),
        children: (content === null || content === void 0 ? void 0 : content.length) > 0 && (content === null || content === void 0 ? void 0 : content.map(function(_param, i) {
            var type = _param.type, props = (0,_object_without_properties/* default */.Z)(_param, [
                "type"
            ]);
            switch(type){
                case storyblok_types/* STORYBLOK_COMPONENTS.QUOTE */.bY.QUOTE:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_Quote, (0,_object_spread/* default */.Z)({
                        className: RightColumnRow_cx((RightColumnRow_styles_module_default()).item, (RightColumnRow_styles_module_default()).Quote)
                    }, props), "right_column_item_".concat(i));
                case "two-columns-accordion":
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_TwoColumnsAccordion, (0,_object_spread/* default */.Z)({
                        className: RightColumnRow_cx((RightColumnRow_styles_module_default()).item, (RightColumnRow_styles_module_default()) === null || (RightColumnRow_styles_module_default()) === void 0 ? void 0 : (RightColumnRow_styles_module_default()).TwoColumnsAccordion),
                        headlineClassName: headlineStyle,
                        bordersTheme: colors/* GlobalThemeColors.SilverChalice */.b.SilverChalice
                    }, props), "right_column_item_".concat(i));
                case storyblok_types/* STORYBLOK_COMPONENTS.IMAGE_WITH_LABEL */.bY.IMAGE_WITH_LABEL:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithLabel/* default */.ZP, (0,_object_spread/* default */.Z)({
                        className: RightColumnRow_cx((RightColumnRow_styles_module_default()).item, (RightColumnRow_styles_module_default()).ImageWithLabel),
                        layout: (content === null || content === void 0 ? void 0 : content.length) === 2 ? ImageWithLabel/* IMAGE_SIZE.SMALL */.WQ.SMALL : ImageWithLabel/* IMAGE_SIZE.LARGE */.WQ.LARGE
                    }, props), "right_column_item_".concat(i));
                case storyblok_types/* STORYBLOK_COMPONENTS.WYSIWYG */.bY.WYSIWYG:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wysiwyg/* default */.Z, (0,_object_spread/* default */.Z)({
                        className: RightColumnRow_cx((RightColumnRow_styles_module_default()).item, (RightColumnRow_styles_module_default()).Wysiwyg)
                    }, props), "right_column_item_".concat(i));
                case storyblok_types/* STORYBLOK_COMPONENTS.TEXT_ACCORDION */.bY.TEXT_ACCORDION:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_AccordionItems, (0,_object_spread/* default */.Z)({
                        className: (RightColumnRow_styles_module_default()).item,
                        bodyClassName: bodyStyle,
                        headlineClassName: headlineStyle,
                        bordersTheme: colors/* GlobalThemeColors.SilverChalice */.b.SilverChalice
                    }, props), "right_column_item_".concat(i));
                case storyblok_types/* STORYBLOK_COMPONENTS.TABLE */.bY.TABLE:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_CustomTable, (0,_object_spread/* default */.Z)({
                        className: RightColumnRow_cx((RightColumnRow_styles_module_default()).item, (RightColumnRow_styles_module_default()).Table)
                    }, props), "right_column_item_".concat(i));
                case storyblok_types/* STORYBLOK_COMPONENTS.IMAGE_WITH_PINS */.bY.IMAGE_WITH_PINS:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsPins/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: RightColumnRow_cx((RightColumnRow_styles_module_default()).item, (RightColumnRow_styles_module_default()).ImageWithLabel)
                    }, props), {
                        layout: (content === null || content === void 0 ? void 0 : content.length) === 2 ? ImageWithLabel/* IMAGE_SIZE.SMALL */.WQ.SMALL : ImageWithLabel/* IMAGE_SIZE.LARGE */.WQ.LARGE
                    }), "right_column_item_".concat(i));
                default:
                    return null;
            }
        }))
    });
}
/* harmony default export */ var RightColumnRow = (ColumnRow);

// EXTERNAL MODULE: ./src/components/UI/TwoColumnsLayout/styles.module.scss
var TwoColumnsLayout_styles_module = __webpack_require__(75379);
var TwoColumnsLayout_styles_module_default = /*#__PURE__*/__webpack_require__.n(TwoColumnsLayout_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/TwoColumnsLayout/index.tsx







var TwoColumnsLayout_cx = bind_default().bind((TwoColumnsLayout_styles_module_default()));
var TwoColumnsLayoutsTypes = {
    HALVES: "halves",
    THIRDS: "thirds"
};
function TwoColumnsLayout(param) {
    var className = param.className, leftColumnClassName = param.leftColumnClassName, rightColumnClassName = param.rightColumnClassName, leftColumnComponents = param.leftColumnComponents, rightColumnComponents = param.rightColumnComponents, layout = param.layout;
    var content = rightColumnComponents === null || rightColumnComponents === void 0 ? void 0 : rightColumnComponents.map(function(row, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RightColumnRow, (0,_object_spread/* default */.Z)({
            className: TwoColumnsLayout_cx((TwoColumnsLayout_styles_module_default()).row)
        }, row), "row_".concat(index));
    });
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: TwoColumnsLayout_cx((TwoColumnsLayout_styles_module_default()).TwoColumnsLayout, className, gridStyle, (TwoColumnsLayout_styles_module_default()) === null || (TwoColumnsLayout_styles_module_default()) === void 0 ? void 0 : (TwoColumnsLayout_styles_module_default())[layout]),
        children: [
            leftColumnComponents && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: TwoColumnsLayout_cx((TwoColumnsLayout_styles_module_default()).leftColumn, leftColumnClassName, {
                    empty: (leftColumnComponents === null || leftColumnComponents === void 0 ? void 0 : leftColumnComponents.length) === 0
                }),
                children: leftColumnComponents
            }),
            rightColumnComponents && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: TwoColumnsLayout_cx((TwoColumnsLayout_styles_module_default()).rightColumn, rightColumnClassName),
                children: content
            })
        ]
    });
}
TwoColumnsLayout.defaultProps = {};
/* harmony default export */ var UI_TwoColumnsLayout = (TwoColumnsLayout);


/***/ }),

/***/ 13717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Table":"styles_Table__zNkcK","hideOnSmallScreen":"styles_hideOnSmallScreen__XYFkC","hideOnLargeScreen":"styles_hideOnLargeScreen__meEsb"};

/***/ }),

/***/ 34928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Accordion":"styles_Accordion___EUyI","whiteTheme":"styles_whiteTheme__gCNjY","blackTheme":"styles_blackTheme__IeNdX","concreteTheme":"styles_concreteTheme__ukGVI","scorpionTheme":"styles_scorpionTheme__D_Gde","silver-chaliceTheme":"styles_silver-chaliceTheme__ZHRBm","altoTheme":"styles_altoTheme__l7fvB","silverTheme":"styles_silverTheme__OjQIV","grayTheme":"styles_grayTheme__I3j3a","cod-grayTheme":"styles_cod-grayTheme__kmCbb","mine-shaftTheme":"styles_mine-shaftTheme__iZ4U4","williamTheme":"styles_williamTheme___RWqs","redTheme":"styles_redTheme__v6v_F","eunryTheme":"styles_eunryTheme__m2kQa","irish-coffeeTheme":"styles_irish-coffeeTheme__SzcNW","amberTheme":"styles_amberTheme__bU8nS","transparentTheme":"styles_transparentTheme__zRgHi","panel":"styles_panel__5q3Oy","panelHead":"styles_panelHead__uYpWY","headline":"styles_headline__bB7c_","icon":"styles_icon__emNxv","panelBody":"styles_panelBody__cOhmN","isActive":"styles_isActive__NHPcN"};

/***/ }),

/***/ 37384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CustomTable":"styles_CustomTable__l8QjM","wrapper":"styles_wrapper__WQOy4","tableContainer":"styles_tableContainer__NZgeQ","table":"styles_table__iRMG6","navIcon":"styles_navIcon__95Lbr","prev":"styles_prev__vmwfR","next":"styles_next__0Im_O","nav":"styles_nav__a3vCH"};

/***/ }),

/***/ 51896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Quote":"styles_Quote__Htskx","cite":"styles_cite__FUXyd","quote":"styles_quote__uHzaT"};

/***/ }),

/***/ 20061:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Table":"styles_Table__kEMzF","thead":"styles_thead__fliSZ","tbody":"styles_tbody__I_tl_","tbodyDesktop":"styles_tbodyDesktop__O8MUw","firstColumnDesktop":"styles_firstColumnDesktop__jQjwi"};

/***/ }),

/***/ 37023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TwoColumnsAccordion":"styles_TwoColumnsAccordion__xnZ5L","panel":"styles_panel__kOR_j","panelHead":"styles_panelHead__y6GfR","panelBody":"styles_panelBody__SzbJ9","row":"styles_row__6lPkX","headline":"styles_headline__FKG7i","icon":"styles_icon__L_03c"};

/***/ }),

/***/ 26182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RightColumnRow":"styles_RightColumnRow__pMcfC","item":"styles_item___pROA","layout-1-items":"styles_layout-1-items__zyPjK","singleHalfWidth":"styles_singleHalfWidth__FeLsn","layout-2-items":"styles_layout-2-items__OrFdL","ImageWithLabel":"styles_ImageWithLabel__qYbxa"};

/***/ }),

/***/ 75379:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TwoColumnsLayout":"styles_TwoColumnsLayout__peDJl","rightColumn":"styles_rightColumn__oBgpF","leftColumn":"styles_leftColumn__0kOjJ","thirds":"styles_thirds__E_nXe","halves":"styles_halves__eEpP8","empty":"styles_empty__BcA49","row":"styles_row___XHpn","layout-2-elements":"styles_layout-2-elements__Pp6QP","item":"styles_item___I0Op","ImageWithLabel":"styles_ImageWithLabel__JBBKv"};

/***/ })

}]);